import type { JourneyStage } from "../data/journeyStages";
import { EvidenceTag } from "../evidence/EvidenceTag";

/**
 * Vista alternativa 2D accesible de una etapa: mismo contenido que la
 * escena 3D, navegable por teclado con foco visible.
 */
export function StagePanel({ stage, index, total }: { stage: JourneyStage; index: number; total: number }) {
  return (
    <article
      tabIndex={0}
      aria-label={`Etapa ${index + 1} de ${total}: ${stage.title}`}
      className="flex h-full flex-col gap-4 overflow-auto rounded-[var(--radius-md)] bg-[var(--cale-surface-raised)] p-6 shadow-[var(--shadow-panel)]"
    >
      <p className="text-sm text-[var(--cale-ink-muted)]">
        Etapa {index + 1} de {total}
      </p>
      <h2 className="text-2xl font-semibold">{stage.title}</h2>
      <section aria-label="Objetivo">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-[var(--cale-ink-muted)]">Objetivo</h3>
        <p>{stage.objective}</p>
      </section>
      <section aria-label="Interacción">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-[var(--cale-ink-muted)]">Interacción</h3>
        <p>{stage.interaction}</p>
      </section>
      <div className="mt-auto flex flex-col gap-2 border-t border-[var(--cale-border)] pt-4">
        <EvidenceTag kind={stage.tag} />
        <p className="text-xs text-[var(--cale-ink-muted)]">Fuente: {stage.source}</p>
      </div>
    </article>
  );
}
